<template>
    <div class="tw-flex tw-justify-between tw-px-14 tw-pb-6 tw-items-center tw-text-gray-300 tw-font-bold tw-text-lg tw-z-20">
        <i class="fa fa-arrow-left tw-mr-10 tw-cursor-pointer hover:tw-opacity-75" @click="toPreviousQuestion" v-if="current_question_index+1 !== 0 && current_question_index+1 !== 1 && quizSettings.back_forward === '1'"></i>
        <div class="tw-flex tw-flex-col tw-flex-1 tw-text-center tw-relative">
            <div class="quiz-progress-bar tw-w-full tw-relative tw-bg-gray-200 tw-rounded-lg tw-overflow-hidden">
                <div class="quiz-progress-bar-inner tw-absolute tw-top-0 tw-left-0 tw-bg-green-300 tw-h-full tw-bg-green-300" :style="{width: percentageDone + '%'}"></div>
            </div>
            <span class="quiz-progress-count tw-absolute tw-left-0 tw-right-0 tw-text-sm tw-text-gray-300">{{ current_question_index+1 }} / {{ questionsLength }}</span>
        </div>
        <quiz-timer v-if="quizSettings.timer_on === '1' && !quiz_finished && quiz_started" :quizSettings="quizSettings"></quiz-timer>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "QuestionTop",

        props: ['current_question_index', 'display_quiz_ended', 'activeQuestion','quizSettings'],

        computed: {
            ...mapState('quiz', [
                'given_answers',
                'questions',
                'quiz_finished',
                'quiz_started',
            ]),

            questionsLength() {
                return this.$store.getters['quiz/getAmountOfQuestions'];
            },

            percentageDone() {
                return (this.current_question_index+1) / this.questionsLength * 100;
            }
        },

        methods: {
            toPreviousQuestion() {
                //if(this.quiz_finished) {
                    if(!this.display_quiz_ended) {
                        this.$store.commit('quiz/navigateQuestion', -1);
                    }

                    this.$nextTick(() => {
                        this.$store.commit('quiz/toggleQuizEndDisplay', false);

                        let active_question = this.questions[this.current_question_index];
                        let given_answer = this.$store.getters['quiz/getQuestionProgress'](active_question.id);

                        if(active_question.type === 'true_false' || active_question.type === 'free_form') {
                            this.$store.commit('quiz/confirmAnswer', {is_correct: given_answer.is_correct, correct_answer: given_answer.correct_answer});
                        } else {
                            this.$store.commit('quiz/confirmAnswer', {is_correct: given_answer.is_correct, correct_answer: given_answer.correct_question_option_id});
                        }
                    });
                /*} else {
                    this.$store.commit('quiz/navigateQuestion', -1);
                }*/
            }
        }
    }
</script>

<style lang="scss" scoped>
    .quiz-wrapper {
        .quiz-progress-count {
            bottom: -25px;
        }

        .quiz-progress-bar {
            height: 8px;

            .quiz-progress-bar-inner {
                transition: width 0.15s ease;
            }
        }
    }
</style>